import Styles from './styles.module.scss';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { buildCrossDomainLink} from "../../../utils/buildCrossDomainLink";

const navItems = [
    { label: 'Главная', type: 'next', path: '/' },
    { label: 'FME', type: 'react', path: '/future' },
    { label: 'Команда', type: 'react', path: '/team' },
    { label: 'Текономика', type: 'react', path: '/tokenomics' },
    { label: 'Программа “Апостол”', type: 'react', path: '/apostol' },
    { label: 'Пресейл', type: 'react', path: '/pre-sale' },
];

const Navigation = ({ isMobile }) => {
    const { t, i18n } = useTranslation();
    const locale = i18n.language?.startsWith('ru') ? 'ru' : 'en';

    return (
        <nav className={isMobile ? Styles.mobileNav : Styles.navWrap}>
            {navItems.map((item) =>
                item.type === 'next' ? (
                    <a
                        key={item.label}
                        href={buildCrossDomainLink({
                            baseUrl: process.env.REACT_APP_NEXT_URL,
                            path: item.path,
                            lang: locale,
                        })}
                        className={Styles.navItem}
                    >
                        {t(item.label)}
                    </a>
                ) : (
                    <Link
                        key={item.label}
                        to={item.path}
                        className={Styles.navItem}
                    >
                        {t(item.label)}
                    </Link>
                )
            )}
        </nav>
    );
};

export default Navigation;
